import styled, { css, keyframes, Keyframes } from 'styled-components';
import React from 'react';
import { Box } from '../primitives';

type Props = {
  uri: string;
  width: number;
  height: number;
  stepCount: number;
  spriteWidth: number;
  duration?: number;
  className?: string;
};

const SpriteAnimation = ({
  uri,
  width,
  height,
  stepCount,
  spriteWidth,
  duration = 0.8,
  className,
}: Props) => {
  const play = keyframes`
  from {
    background-position: 0px;
  }
  to {
    background-position: -${spriteWidth - width}px;
  }
`;

  return (
    <SSprite
      className={className}
      background={`url(${uri}) no-repeat`}
      width={width}
      height={height}
      stepCount={stepCount}
      duration={duration}
      play={play}
    />
  );
};

const getAnimation = (anim: Keyframes) => css`
  ${anim};
`;

const SSprite = styled(Box)<{
  stepCount: number;
  duration: number;
  play: Keyframes;
}>`
  animation: ${({ play }) => getAnimation(play)};
  animation-timing-function: ${({ stepCount }) => `steps(${stepCount}, end)`};
  animation-duration: ${({ duration }) => duration}s;
  animation-fill-mode: forwards;
`;

export default SpriteAnimation;
